import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/storage-unit-cost.jpg'),
    alt: 'storage unit cost page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'storage unit cost page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Estimate <span>Your Storage</span><span>Unit Cost</span>',
  description:
    "Looking for affordable and reliable storage solutions? Use our storage unit cost estimator to determine the best price for your storage needs, whether it's for personal belongings, business inventory, or seasonal items.",
  image: {
    url: '/images/v2/pages/landing-pages/storage-unit-cost/hero-image.jpg',
    alt: 'Estimate Your Storage Unit Cost'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Get Storage Unit Cost Estimate' }
}

export const ourProcessSectionContent = {
  title: 'How Our Storage Unit Cost Estimator Works',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/storage-unit-cost/how-our-storage-unit-cost-estimator-works.png',
    alt: 'How Our Storage Unit Cost Estimator Works'
  },

  articles: [
    {
      id: 1,
      title: 'Enter Your Storage Requirements',
      description:
        'Fill out the details, such as the size of the unit and the duration of storage, to receive an accurate cost estimate tailored to your needs.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-unit-cost/enter-your-storage-requirements.png',
        alt: 'Enter Your Storage Requirements'
      }
    },
    {
      id: 2,
      title: 'Affordable Pricing Options',
      description:
        'Our tool adjusts the pricing based on your selected storage needs, helping you find the best solution within your budget.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-unit-cost/affordable-pricing-options.png',
        alt: 'Affordable Pricing Options'
      }
    },
    {
      id: 3,
      title: 'Transparent Cost Breakdown',
      description:
        'You’ll get a clear, itemized breakdown of the storage cost with no hidden fees, so you know exactly what to expect.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-unit-cost/transparent-cost-breakdown.png',
        alt: 'Transparent Cost Breakdown'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Affordable Storage Unit Costs',
  description:
    "When considering affordable storage unit costs, it's essential to evaluate factors like size, location, and rental duration. Understanding these elements helps you budget effectively, avoid hidden fees, and select the right storage option for your needs, ensuring a smooth and hassle-free experience without unexpected expenses.",
  image: {
    src: '/images/v2/pages/landing-pages/storage-unit-cost/affordable-storage-unit-costs.jpg',
    alt: 'Affordable Storage Unit Costs'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Our Storage Unit Cost Estimator',

  cards: [
    {
      id: 1,
      title: 'Affordable Pricing',
      description:
        'Our storage solutions are designed to fit every budget, offering competitive pricing for both short-term and long-term storage.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-unit-cost/affordable-pricing.png',
        alt: 'Affordable Pricing'
      }
    },
    {
      id: 2,
      title: 'Instant Cost Estimate',
      description: 'Get an accurate price instantly, helping you make an informed decision without wasting time.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-unit-cost/instant-cost-estimate.png',
        alt: 'Instant Cost Estimate'
      }
    },
    {
      id: 3,
      title: 'Clear, Transparent Pricing',
      description:
        'No hidden charges – what you see is what you get. We believe in honesty and transparency in all our pricing.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-unit-cost/clear-transparent-pricing.png',
        alt: 'Clear, Transparent Pricing'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use the Storage Unit Cost Estimator?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Homeowners',
          description:
            'Estimate the cost of storing personal items, furniture, or seasonal belongings with affordable, flexible storage options.'
        },
        {
          id: 2,
          title: 'Students',
          description:
            'Easily calculate the cost of storing dorm room or apartment belongings during breaks or between terms.'
        },
        {
          id: 3,
          title: 'Business Owners',
          description:
            'Estimate the cost of storing business inventory, documents, or office equipment securely and affordably.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/storage-unit-cost/who-should-use-the-storage-unit-cost-estimator.jpg',
        alt: 'Who Should Use the Storage Unit Cost Estimator?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Explore Our Additional Storage Solutions',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solution',
      description:
        'Need secure storage for business inventory, equipment, or documents? Get a cost estimate for tailored storage solutions.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Business Storage' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        'Store your belongings while transitioning between homes, getting a clear cost estimate to ensure the best deal for you.',
      image: {
        src: '/images/v2/pages/common/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Moving Storage' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description: 'Estimate the cost of storing and shipping your luggage or boxes locally and internationally.',
      image: {
        src: '/images/v2/pages/common/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Box Storage' }
    },
    {
      id: 4,
      title: 'Seasonal Storage Solution',
      description:
        'Store seasonal items like winter gear or holiday decorations at an affordable price with flexible rental terms.',
      image: {
        src: '/images/v2/pages/common/residential-storage-services.png',
        alt: 'Seasonal Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Seasonal Solution Storage' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Your Storage Unit Cost?',

  image: {
    url: '/images/v2/pages/landing-pages/storage-unit-cost/why-choose-shipandstorage-for-your-storage-unit-cost.jpg',
    alt: 'Why Choose ShipAndStorage for Your Storage Unit Cost?'
  },

  articles: [
    {
      id: 1,
      title: 'Clear Pricing Structure',
      description:
        'Get an honest and transparent breakdown of costs for all our storage units, ensuring no surprises at checkout.'
    },
    {
      id: 2,
      title: '24/7 Secure Access',
      description:
        'Our storage units are equipped with top-tier security, giving you peace of mind about the safety of your belongings.'
    },
    {
      id: 3,
      title: 'Affordable Rates for Everyone',
      description:
        'We offer cost-effective pricing that works within your budget, with no hidden fees or complicated terms.'
    },
    {
      id: 4,
      title: 'Flexible Rental Terms',
      description: 'Rent storage for as long or short as you need – we offer flexible terms to suit your schedule.'
    },
    {
      id: 5,
      title: 'Flexible Storage Options',
      description: 'Choose from a variety of unit sizes, ensuring you only pay for the space you need.'
    },
    {
      id: 6,
      title: 'Customer-Centered Service',
      description:
        'Our team is dedicated to providing you with a hassle-free experience from start to finish, answering all your questions along the way.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Get an Accurate Estimate of Your Storage Unit Cost',
  description:
    'Get an accurate estimate of your storage unit cost. Affordable, reliable solutions for renting a unit tailored to your specific needs.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-unit-cost/get-an-accurate-estimate-of-your-storage-unit-cost.png',
    alt: 'Get an Accurate Estimate of Your Storage Unit Cost'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Your Estimate Today' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage Partners',
  description:
    'ShipAndStorage collaborates with top logistics providers to ensure your items are securely stored and accessible at all times.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx ensures your items are shipped and stored with the utmost care, providing reliable services worldwide.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com.</a> FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL offers trusted logistics and storage services, helping you keep your belongings safe and secure.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS provides secure and affordable storage options, ensuring your items are always safe and accessible.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
